











































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Customers extends Vue {
  @Prop({ default: false }) readonly active!: boolean;
}
